<template>
  <div class="cards-filters-beeline">


    <div class="cards-filters-beeline-side">
      <search-input
        v-if="isFilterVisible('search')"
        style="width: 300px"
        v-model="filters.search"
        @change="filtersChanged"
      >
      </search-input>

      <cards-year-select
        v-if="isFilterVisible('years')"
        style="width:100px"
        v-model="filters.years"
        @change="filtersChanged"
      ></cards-year-select>

<!--      <cards-period-select-->
<!--        v-if="isFilterVisible('periods')"-->
<!--        style="width:100px"-->
<!--        v-model="filters.periods"-->
<!--        @change="filtersChanged"-->
<!--      ></cards-period-select>-->

      <cards-stage-select
        v-if="isFilterVisible('stages')"
        multiple
        v-model="filters.stages"
        @change="filtersChanged"
      ></cards-stage-select>

      <cards-status-select
        v-model="filters.statuses"
        placeholder="Статус"
        style="width: 190px"
        @change="filtersChanged"
      ></cards-status-select>

      <cards-stage-negotiation-select
        v-if="isFilterVisible('negotiations')"
        v-model="filters.negotiations"
        multiple
        @change="filtersChanged"
      ></cards-stage-negotiation-select>

      <el-select
        v-model="availableCards"
        multiple
        placeholder="Доступные карты"
      >
        <el-option label="Мои карты" value="my"></el-option>
        <el-option label="На моем шаге" value="my_turn"></el-option>
        <el-option label="Карты непосредственных подчиненных" value="subordinates"></el-option>
        <el-option label="Карты непосредственных подчиненных +1" value="subordinates_n1"></el-option>
        <el-option label="Карты всех подчиненных" value="allSubordinates"></el-option>
      </el-select>

      <el-select
        v-model="filters.closed_route"
        style="width: 180px"
        placeholder="Закрытый маршрут"
        clearable
        @change="filtersChanged"
      >
        <el-option label="Да" :value="1"></el-option>
        <el-option label="Нет" :value="0"></el-option>
      </el-select>

      <!--      <search-input-->
      <!--        placeholder="Ответственный"-->
      <!--        style="width: 200px"-->
      <!--        v-model="filters.negotiation_user_fio"-->
      <!--        @change="filtersChanged"-->
      <!--      >-->
      <!--      </search-input>-->
    </div>


    <div class="cards-filters-beeline-side">
      <el-popconfirm
        v-if="$canAndRulesPass(user, 'setting.back_integration')"
        confirm-button-text='Да'
        cancel-button-text='нет'
        icon="el-icon-question"
        title="Вы уверены, что хотите выгрузить данные в SAP?"
        @confirm="doIntegration"
      >
        <el-button
          slot="reference"
          size="small"
          :loading="loadingIntegration"
        >
          Выгрузить данные в SAP
        </el-button>
      </el-popconfirm>

      <el-button
        v-if="!filterDeleted && isFilterVisible('export_cards') && $canAndRulesPass(user, 'card.export_list_for_export')"
        style="margin-left:0"
        size="small"
        icon="fas fa-file-excel"
        @click="exportToExcel"
      >
        Экспорт в XLSX
      </el-button>
    </div>



  </div>
</template>

<script>

import SearchInput from "@/components/filters/SearchInput";
import CardsYearSelect from "@/components/filters/cards/CardsYearSelect";
import CardsStageSelect from "@/components/filters/cards/CardsStageSelect";
import CardsStageNegotiationSelect from "@/components/filters/cards/CardsStageNegotiationSelect.vue";
import CardsPeriodSelect from "@/components/filters/cards/CardsPeriodSelect.vue";
import {downloader} from "@/mixins/downloader";
import {mapGetters} from "vuex";
import requestSender from "@/api/base/requestSender";
import CardsStatusSelect from "@/components/filters/cards/CardsStatusSelect.vue";

export default {
  name: "cards-page-filters",
  mixins: [downloader],
  components: {
    CardsStatusSelect,
    CardsPeriodSelect, CardsStageNegotiationSelect, CardsStageSelect, CardsYearSelect, SearchInput},

  props: {
    value: {},
    hidden: {type: Array},
    filterDeleted: {type: Boolean, default: false},
  },

  computed: {
    ...mapGetters(['user'])
  },
  watch: {
    availableCards: function () {
      this.filters.my = this.availableCards.includes('my') ? 1 : null;
      this.filters.my_turn = this.availableCards.includes('my_turn') ? 1 : null;

      if( this.availableCards.includes('allSubordinates') ){
        this.filters.subordinates = this.$constants.user.subordinates.SUBORDINATES_ALL;
      } else if( this.availableCards.includes('subordinates_n1') ){
        this.filters.subordinates = this.$constants.user.subordinates.SUBORDINATES_N1;
      } else if( this.availableCards.includes('subordinates') ){
        this.filters.subordinates = this.$constants.user.subordinates.SUBORDINATES_DIRECT;
      } else {
        this.filters.subordinates = this.$constants.user.subordinates.SUBORDINATES_NONE;
      }



      this.filtersChanged();
    },
  },
  data() {
    return {
      loadingIntegration: false,

      subordinates: false,
      allSubordinates: false,

      availableCards: [],
      filters: {
        search: null,
        years: [],
        periods: [],
        stages: [],
        statuses: [],
        negotiations: [],
        negotiation_user_fio: null,
        my: null,
        my_turn: null,
        subordinates: null,
        closed_route: null,
      },
    }
  },
  beforeMount() {
    const q = this.$route.query;

    if (q.search) this.filters.search = q.search;
    if (q.negotiation_user_fio) this.filters.negotiation_user_fio = q.negotiation_user_fio;
    if (q.closed_route !== undefined && q.closed_route !== '') {
      this.filters.closed_route = Number(q.closed_route);
    }

    if (q.years) {
      this.filters.years = (Array.isArray(q.years) ? q.years : [q.years]).map(Number);
    }
    if (q.periods) {
      this.filters.periods = (Array.isArray(q.periods) ? q.periods : [q.periods]).map(Number);
    }
    if (q.stages) {
      this.filters.stages = Array.isArray(q.stages) ? q.stages : [q.stages];
    }
    if (q.statuses) {
      this.filters.statuses = Array.isArray(q.statuses) ? q.statuses : [q.statuses];
    }
    if (q.negotiations) {
      this.filters.negotiations = Array.isArray(q.negotiations) ? q.negotiations : [q.negotiations];
    }

    if (q.my) {
      this.filters.my = 1;
      this.availableCards.push('my');
    }
    if (q.my_turn) {
      this.filters.my_turn = 1;
      this.availableCards.push('my_turn');
    }
    if (q.subordinates) {
      const sub = Number(q.subordinates);
      this.filters.subordinates = sub;
      if (sub === this.$constants.user.subordinates.SUBORDINATES_ALL) {
        this.availableCards.push('allSubordinates');
      } else if (sub === this.$constants.user.subordinates.SUBORDINATES_N1) {
        this.availableCards.push('subordinates_n1');
      } else if (sub === this.$constants.user.subordinates.SUBORDINATES_DIRECT) {
        this.availableCards.push('subordinates');
      }
    }

    if (this.filters.my_turn) {
      this.subordinates = false;
    }
  },
  mounted() {
    this.filters = {...this.filters, ...this.value};
    if( this.filters.my_turn ){
      this.filters.my = null;
      this.filters.allSubordinates = 1;
    }

    if (!this.filters.years || !this.filters.years.length) {
      this.filters.years = [this.getDefaultYear()];
    }

    this.filtersChanged()
  },
  methods: {
    getDefaultYear() {
      const now = new Date();
      const currentYear = now.getFullYear();
      const march15 = new Date(currentYear, 2, 15);

      return now < march15 ? currentYear - 1 : currentYear;
    },
    filtersChanged() {
      this.$emit('input', this.filters);
      this.$emit('change', this.filters);
      this.updateQueryParams();
    },

    updateQueryParams() {
      const query = {};

      if (this.filters.search) query.search = this.filters.search;
      if (this.filters.negotiation_user_fio) query.negotiation_user_fio = this.filters.negotiation_user_fio;
      if (this.filters.closed_route !== null && this.filters.closed_route !== undefined) {
        query.closed_route = this.filters.closed_route;
      }
      if (this.filters.my) query.my = this.filters.my;
      if (this.filters.my_turn) query.my_turn = this.filters.my_turn;
      if (this.filters.subordinates) query.subordinates = this.filters.subordinates;
      if (this.filters.years && this.filters.years.length) query.years = this.filters.years;
      if (this.filters.periods && this.filters.periods.length) query.periods = this.filters.periods;
      if (this.filters.stages && this.filters.stages.length) query.stages = this.filters.stages;
      if (this.filters.statuses && this.filters.statuses.length) query.statuses = this.filters.statuses;
      if (this.filters.negotiations && this.filters.negotiations.length) query.negotiations = this.filters.negotiations;

      if (this.$route.query['per-page']) query['per-page'] = this.$route.query['per-page'];

      this.$router.replace({path: this.$route.path, query}).catch(() => {});
    },

    preCheckChange(filter, value) {
      if (filter === 'my' && value) {
        this.subordinates = false;
        this.allSubordinates = false;
      }
      if (filter === 'subordinates' && value) {
        this.filters.my = null;
        this.filters.allSubordinates = null;
      }
      if (filter === 'subordinates' && !value) {
        this.filters.allSubordinates = null;
      }
      this.filtersChanged();
    },

    isFilterVisible(filterName){
      if( this.hidden && this.hidden.includes(filterName) ){
        return false;
      }
      return true;
    },

    exportToExcel() {
      this.downloadFile(
        false,
        this.$api.exportImport.export,
        {
          entity: 'cards',
          data: this.filters
        }
      )
    },

    doIntegration(){
      this.loadingIntegration = true;
      requestSender('get', 'cherkizovo-back-integration/upload-cards-data', {
        ...this.filters,
      })
        .then(data => {
          this.$notify.success({
            title: 'Отправлено',
            message: 'Задача на интеграцию успешно добавлена в очередь'
          });
        })
        .finally(()=>{
          this.loadingIntegration = false;
        })
    },
  }
}
</script>


<style lang="scss">

.cards-filters-beeline {
  display: flex;
  justify-content: space-between;
  gap: 1.5rem;

  &-side {
    align-items: flex-start;
    display: flex;
    gap: 1.5rem;
  }
}
</style>